// extracted by mini-css-extract-plugin
export var textInput = "_it-0";